import { render, staticRenderFns } from "./KBMoney.vue?vue&type=template&id=00333cd8&scoped=true&"
import script from "./KBMoney.vue?vue&type=script&lang=js&"
export * from "./KBMoney.vue?vue&type=script&lang=js&"
import style0 from "./KBMoney.vue?vue&type=style&index=0&id=00333cd8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00333cd8",
  null
  
)

export default component.exports